import React from "react";

import {
    APP_SET_ALERT,
    APP_SET_LEFT_DRAWER_OPEN,
    APP_SET_RIGHT_DRAWER_OPEN,
    APP_TOOLBAR_HEIGHT,
    APP_SET_SETTINGS_CONTENT,
    APP_UPDATE_ROUTES,
    APP_ACTIVE_PAGE_TITLE,
    APP_ACTIVE_PAGE_ID,
    APP_SET_PREVIOUS_ROUTE,
    APP_SET_MODAL_CONTENT,
    APP_SET_TOOLTIP_CONTENT,
    APP_SET_GANTT_USER_SELECTIONS,
	APP_SET_UUID
} from "./appTypes";

import * as ParameterUtilities from "../../utilities/ParameterUtilities";

export function appSetLeftDrawerOpen(isOpen) {
    return {
        type: APP_SET_LEFT_DRAWER_OPEN,
        payload: isOpen
    }
}

export function appSetRightDrawerOpen(isOpen) {
    return {
        type: APP_SET_RIGHT_DRAWER_OPEN,
        payload: isOpen
    }
}

export function appSetToolbarHeight(height) {
    return {
        type: APP_TOOLBAR_HEIGHT,
        payload: height
    }
}

export function appSetAlert(title, message, severity, timeout) {
    return {
        type: APP_SET_ALERT,
        payload: { title: title, message: message, severity: severity, timeout: timeout }
    }
}

export function appSetRoutes(routes) {
    return (dispatch, getState) => {
        // const state = getState();

        const appRoutes = [].concat(routes);

        // Sort the routes
        appRoutes.sort((a, b) => (a.seqNo < b.seqNo) ? 1 : -1)

        dispatch ({
            type: APP_UPDATE_ROUTES,
            payload: appRoutes
        });
    }
}

export function appClearRoutes() {
    return {
        type: APP_UPDATE_ROUTES,
        payload: []
    }
}

export function appSetPreviousRoute(route) {
    return {
        type: APP_SET_PREVIOUS_ROUTE,
        payload: route
    }
}

export function appSetSettingsContent(config) {
    return {
        type: APP_SET_SETTINGS_CONTENT,
        payload: config
    }
}

export function appSetModalContent(config) {
    return {
        type: APP_SET_MODAL_CONTENT,
        payload: config
    }
}

export function appSetTooltipContent(config) {
    return {
        type: APP_SET_TOOLTIP_CONTENT,
        payload: config
    }
}

export function appSetActivePageTitle(params) {
    return (dispatch, getState) => {
        const state = getState();

        const activeRoute = state.router.location.pathname;
        const routes = state.app.routes;

        let paramString = '';
        params.forEach( (p, i) => paramString += '/' + params[i]);

        let routeObj = routes.find(item => ParameterUtilities.trimParams(item.route) === activeRoute.replace(paramString, ''));

        if (routeObj) {
            dispatch({
                type: APP_ACTIVE_PAGE_TITLE,
                payload: { pageTitle: routeObj.pageTitle }
            });
        } else {
            dispatch({
                type: APP_ACTIVE_PAGE_TITLE,
                payload: { pageTitle: "Project Hub" }
            });
        }
    }
}

export function appSetActivePageID(pageID) {
    return {
        type: APP_ACTIVE_PAGE_ID,
        payload: pageID
    }
}

export function appSetGanttUserSelections(id, userSelection) {
    return (dispatch, getState) => {
        const state = getState();
        const ganttUserSelections = state.app.ganttUserSelections;

        // Does a reference for the Gantt or Gantt Modal exist?
        const ganttSelections = ganttUserSelections.find(f => {
            const i = f.id;
            const replacedID = i.replace("-m", "");     // only saving primary component id, -m represents the components modal equivalent
            const idFound = id.startsWith(replacedID);

            if (idFound) {
                return true
            } else {
                return false
            }
        });
        let ganttArray = [];

        // console.log(id);
        // console.log(userSelection);
        // console.log('ganttUserSelections: ', ganttUserSelections);
        // console.log('ganttSelections: ', ganttSelections);

        if (!ganttSelections) {
            // Create new Object
            ganttArray.push({
                id: id.replace("-m", ""),   // do not save modal ID, but rather save the primary component ID
                selections: userSelection
            });
        }
        else {
            const userSelectionIndex = ganttUserSelections.findIndex(f => f.id === id);

            // Merge into existing Object
            const selections = ganttSelections.selections;
            ganttSelections.selections = {...selections, ...userSelection}

            ganttArray = ganttUserSelections;
            ganttArray.splice(userSelectionIndex, 1, ganttSelections);
        }

        dispatch({
            type: APP_SET_GANTT_USER_SELECTIONS,
            payload: ganttArray
        });
    }
}

export function appSetUUID(uuid) {
	return {
		type: APP_SET_UUID,
		payload: uuid
	}
}
